module.exports = __webpack_public_path__ + "img/horsemackerel.ff117895.png";